import { axiosInstance, axiosNewAPiInstance, getAuthorizationHeaders } from './base';

/*Employee Api Endpoints*/
const roleUrlString = localStorage.getItem('mainRole') === 'pm' ? `pm/attendancelogs` : `attendancelogs`;
export function getAttendanceByUser(userId) {
    const urlString = `/today/per/user/${userId}`;
    return axiosInstance.get(roleUrlString + urlString, getAuthorizationHeaders());
}
export function getAttendanceByUserV2() {
    const urlString = `/api/v1/users/attendance/get-todays-attendancelog`;
    return axiosNewAPiInstance.get(urlString, getAuthorizationHeaders());
}

export function updateClockOut(id, data) {
    const urlString = `/${id}/clock-out`;
    return axiosInstance.patch(roleUrlString + urlString, data, getAuthorizationHeaders());
}

export function postClockIn(data) {
    const urlString = `/clock-in`;
    return axiosInstance.post(roleUrlString + urlString, data, getAuthorizationHeaders());
}

export function postClockInV2() {
    return axiosNewAPiInstance.post('/api/v1/users/attendance/clockIn', {}, getAuthorizationHeaders());
}

export function postClockOutV2() {
    return axiosNewAPiInstance.post('/api/v1/users/attendance/clockOut', {}, getAuthorizationHeaders());
}
export function getPaginatedAttendanceRecords(userId, filter, page = 1, limit = 1000) {
    const urlString = `/paginated/${userId}/records`;
    return axiosInstance.get(roleUrlString + urlString, {
        params: { filter: filter, limit: limit, page: page, sort: { clockInTime: 1 } },
        ...getAuthorizationHeaders(),
    });
}

export function getPaginatedAttendanceRecordsPM(userId, filter, page = 1, limit = 15) {
    const urlString = `/api/v1/pm/attendance/user/${userId}/get-recent-attendance`;
    return axiosNewAPiInstance.get(urlString, {
        params: { filter: filter, limit: limit, page: page, sort: { clockInTime: 1 } },
        ...getAuthorizationHeaders(),
    });
}


export function getAttendanceRecordById(id) {
    const urlString = `/${id}`;
    return axiosInstance.get(roleUrlString + urlString, getAuthorizationHeaders());
}
/*Admin Api Endpoints*/
export function getAdminPaginatedAttendanceRecords(filter, page = 1, limit = 1000) {
    const urlString = `admin/${roleUrlString}/get-paginated-aggregated-attendance-records`;
    return axiosInstance.get(urlString, {
        params: { filter: filter, limit: limit, page: page, sort: { clockInTime: 1 } },
        ...getAuthorizationHeaders(),
    });
}
export function getAdminAttendanceRecordsToCsv({user, dateFrom, dateTo}) {
    const urlString = `admin/attendancelogs/get-attendance-to-csv-format`;
    return axiosInstance.get(urlString, {
        params: { user: user, dateFrom, dateTo },
        responseType: 'blob',
        headers: {
            ...getAuthorizationHeaders().headers,
        },
    });
}

